import classNames from 'classnames'
import React from 'react'
import { motion } from 'framer-motion'
import { countWidthRate } from '../../../pages/surveys/helpers'

interface IProps {
  maxValue: number
  optionCount: number
  totalCount: number
}

export const AggregatedResultBar = ({
  maxValue,
  optionCount,
  totalCount
}: IProps) => {
  const animation = {
    initial: {
      width: '0%'
    },
    animate: {
      width: `${countWidthRate(optionCount, totalCount)}`
    }
  }

  return (
    <div className="AggregatedResult__bar__wrapper">
      <motion.div
        className={classNames('AggregatedResult__bar', {
          'AggregatedResult__bar--max': maxValue === optionCount
        })}
        {...animation}
      >
        <span className="AggregatedResult__bar__value">
          {countWidthRate(optionCount, totalCount)}
        </span>
      </motion.div>
    </div>
  )
}
